// js/data/levels.js
// 資料驅動關卡定義。座標為「格」單位（x: 0..20, y: 0..12），容許小數。
// 結構對齊規劃文件第 6 節；規則與目標皆由資料描述，不寫死在畫面元件。

export const LEVELS = [
  // ============ 住宅區（教學／基礎）============
  {
    id: 'harbor_001',
    region: 'harbor',
    name: '遲到扣人工',
    tags: ['tutorial'],
    start: { x: 3, y: 6 },
    destinations: [{ id: 'home_01', x: 17, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [], hazards: [], collectibles: [],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.4, durability: 100, turn_resistance: 0.45, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'noCollision', text: '全程不碰撞' },
      { type: 'efficiency', maxLength: 17, text: '路線長度 ≤ 17 格' },
    ],
    rewards: { coffee: 10, materials: 4 },
    hint: '黎先生，今日又就黎遲到了！用手指幫佢規劃一條返公司既路線，放開就會出發！',
  },
  {
    id: 'harbor_002',
    region: 'harbor',
    name: '地盤佬地盤',
    tags: ['tutorial', 'precision'],
    start: { x: 3, y: 9.5 },
    destinations: [{ id: 'home_01', x: 17, y: 2.5, r: 1.1 }],
    terrain: [[
      { x: 8.5, y: 2 }, { x: 11.5, y: 2 }, { x: 13, y: 6 },
      { x: 11.5, y: 10 }, { x: 8.5, y: 10 }, { x: 7, y: 6 },
    ]],
    currents: [], windZones: [], hazards: [], collectibles: [],
    rules: { maxRouteLength: 30, inkUses: 1 },
    boat: { speed: 3.4, durability: 100, turn_resistance: 0.45, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'noCollision', text: '不撞到工地' },
      { type: 'efficiency', maxLength: 25, text: '路線長度 ≤ 25 格' },
    ],
    rewards: { coffee: 12, materials: 5 },
    hint: '中間有個工地擋路，規劃一條繞過它的路線。',
  },
  {
    id: 'harbor_003',
    region: 'harbor',
    name: '俾人推住行',
    tags: ['tutorial', 'wind_introduction'],
    start: { x: 3, y: 6 },
    destinations: [{ id: 'home_01', x: 17, y: 6, r: 1.1 }],
    terrain: [],
    currents: [{ x: 5, y: 4.5, w: 11, h: 3, fx: 2.6, fy: 0 }],
    windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 10, y: 3, r: 0.6 }],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.2, durability: 100, turn_resistance: 0.45, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '沿途收集咖啡' },
      { type: 'efficiency', maxLength: 16, text: '路線長度 ≤ 16 格' },
    ],
    rewards: { coffee: 14, materials: 6 },
    hint: '人潮箭頭會推你一把，順著人潮走過去。',
  },
  {
    id: 'harbor_004',
    region: 'harbor',
    name: '人山人海',
    tags: ['multi_delivery', 'precision'],
    start: { x: 3, y: 2.2 },
    destinations: [{ id: 'home_01', x: 17, y: 10, r: 1.1 }],
    terrain: [[{ x: 6, y: 6 }, { x: 9, y: 6 }, { x: 9, y: 9 }, { x: 6, y: 9 }]],
    windZones: [
      { x: 11, y: 2, w: 6, h: 7, fx: 0.8, fy: 1.8 },
      { x: 13, y: 1, w: 6, h: 3, fx: -1.9, fy: 0.2 },
    ],
    currents: [],
    hazards: [{ x: 13, y: 7.2, r: 0.7, damage: 60 }],
    collectibles: [
      { id: 's1', x: 9.2, y: 4.2, r: 0.55 },
      { id: 's2', x: 14.5, y: 9, r: 0.55 },
    ],
    rules: { maxRouteLength: 30, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.45, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '收集全部 2 杯咖啡' },
      { type: 'efficiency', maxLength: 24, text: '路線長度 ≤ 24 格' },
    ],
    rewards: { coffee: 16, materials: 7 },
    hint: '人潮會推著你走，小心路障與側向人潮。',
  },

  // ============ 住宅區（進階）============
  {
    id: 'harbor_005',
    region: 'harbor',
    name: '出盡力頂',
    tags: ['wind_introduction', 'precision'],
    start: { x: 3, y: 6 },
    destinations: [{ id: 'home_01', x: 17, y: 6, r: 1.1 }],
    terrain: [],
    // 中段向上的反向人潮：直線會被往上推，需壓低或繞下方
    windZones: [{ x: 5, y: 4, w: 11, h: 4, fx: 0, fy: -2.0 }],
    currents: [], hazards: [],
    collectibles: [{ id: 's1', x: 12, y: 9.5, r: 0.6 }],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '收集下方咖啡' },
      { type: 'efficiency', maxLength: 20, text: '路線長度 ≤ 20 格' },
    ],
    rewards: { coffee: 16, materials: 7 },
    hint: '中段人潮會把你往上擠，貼住下方或繞路。',
  },
  {
    id: 'harbor_006',
    region: 'harbor',
    name: '左閃右避',
    tags: ['precision'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [],
    hazards: [
      { x: 7, y: 5, r: 0.7, damage: 45 },
      { x: 10, y: 8, r: 0.7, damage: 45 },
      { x: 12.5, y: 4.5, r: 0.7, damage: 45 },
      { x: 14, y: 9, r: 0.7, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 8.5, r: 0.55 },
      { id: 's2', x: 15, y: 5, r: 0.55 },
    ],
    rules: { maxRouteLength: 30, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '收集全部 2 杯咖啡' },
      { type: 'efficiency', maxLength: 26, text: '路線長度 ≤ 26 格' },
    ],
    rewards: { coffee: 18, materials: 8 },
    hint: '路障散布，規劃一條閃過它們的路線。',
  },

  // ============ 商業區 ============
  {
    id: 'river_001',
    region: 'river',
    name: '九曲十三彎',
    tags: ['precision', 'relaxing'],
    start: { x: 2, y: 9 },
    destinations: [{ id: 'home_01', x: 18, y: 3, r: 1.1 }],
    terrain: [
      [{ x: 5, y: 1 }, { x: 8, y: 1 }, { x: 8, y: 5 }, { x: 5, y: 5 }],      // 上中工地
      [{ x: 11, y: 7 }, { x: 14, y: 7 }, { x: 14, y: 11 }, { x: 11, y: 11 }], // 下中工地
    ],
    currents: [], windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 6, y: 7, r: 0.55 },
      { id: 's2', x: 12.5, y: 5, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.35, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '收集全部 2 杯咖啡' },
      { type: 'efficiency', maxLength: 28, text: '路線長度 ≤ 28 格' },
    ],
    rewards: { coffee: 18, materials: 8 },
    hint: '順著街道蜿蜒前進，別撞到工地。',
  },
  {
    id: 'river_002',
    region: 'river',
    name: '搭個順風車',
    tags: ['wind_introduction'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 強勁向東快線（電動行人道）；咖啡在快線之外，得離開快線
    currents: [{ x: 3, y: 5, w: 14, h: 2, fx: 3.0, fy: 0 }],
    windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 8, y: 2.5, r: 0.55 },
      { id: 's2', x: 14, y: 9.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.0, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '收集全部 2 杯咖啡' },
      { type: 'efficiency', maxLength: 20, text: '路線長度 ≤ 20 格' },
    ],
    rewards: { coffee: 20, materials: 9 },
    hint: '快線很快，但兩杯咖啡在快線之外。',
  },

  // ============ 市中心 ============
  {
    id: 'storm_001',
    region: 'storm',
    name: '打晒交咁',
    tags: ['vortex_combo', 'precision'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 四股相反人潮：中央 x9-11 為空檔
    currents: [
      { x: 4, y: 2, w: 5, h: 3, fx: 2.0, fy: 0 },
      { x: 11, y: 2, w: 5, h: 3, fx: -2.0, fy: 0 },
      { x: 4, y: 7, w: 5, h: 3, fx: -1.8, fy: 0 },
      { x: 11, y: 7, w: 5, h: 3, fx: 1.8, fy: 0 },
    ],
    windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 13, y: 3.4, r: 0.6 }],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '深入人潮收集咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 20, materials: 9 },
    hint: '四股人潮互相拉扯，沿中央空檔穿過。',
  },
  {
    id: 'storm_002',
    region: 'storm',
    name: '九點前返到',
    tags: ['multi_delivery', 'vortex_combo', 'precision'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [[{ x: 7, y: 4 }, { x: 10, y: 4 }, { x: 10, y: 6 }, { x: 7, y: 6 }]],
    windZones: [
      { x: 6, y: 1, w: 5, h: 9, fx: 0.6, fy: 1.6 },
      { x: 12, y: 2, w: 6, h: 4, fx: -1.4, fy: 0.6 },
    ],
    currents: [{ x: 3, y: 8, w: 6, h: 3, fx: 1.6, fy: 0 }],
    hazards: [{ x: 13, y: 6.5, r: 0.7, damage: 60 }],
    collectibles: [
      { id: 's1', x: 5, y: 5, r: 0.55 },
      { id: 's2', x: 15.5, y: 7.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '收集全部 2 杯咖啡' },
      { type: 'efficiency', maxLength: 28, text: '路線長度 ≤ 28 格' },
    ],
    rewards: { coffee: 24, materials: 10 },
    hint: '人潮、快線、路障齊聚——這是最後一哩路。',
  },

  // ============ 加時通勤（地獄級）============
  {
    id: 'harbor_007',
    region: 'harbor',
    name: '天橋迷宮',
    tags: ['precision', 'maze'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 三重閘口：左閘封頂、中閘封底、右閘封頂，上落穿梭
    terrain: [
      [{ x: 5, y: 0 }, { x: 6, y: 0 }, { x: 6, y: 8 }, { x: 5, y: 8 }],
      [{ x: 9, y: 3 }, { x: 10, y: 3 }, { x: 10, y: 12 }, { x: 9, y: 12 }],
      [{ x: 13, y: 0 }, { x: 14, y: 0 }, { x: 14, y: 8 }, { x: 13, y: 8 }],
    ],
    currents: [], windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 7.5, y: 6.5, r: 0.6 }],
    rules: { maxRouteLength: 40, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執埋天橋咖啡' },
      { type: 'efficiency', maxLength: 38, text: '路線長度 ≤ 38 格' },
    ],
    rewards: { coffee: 26, materials: 11 },
    hint: '三重閘口上上落落，跟住空檔穿梭。',
  },
  {
    id: 'river_003',
    region: 'river',
    name: '逼爆地鐵',
    tags: ['crowd_lanes', 'precision'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 三條人潮帶：上下順流推進、中間逆流頂住
    currents: [
      { x: 4, y: 1, w: 12, h: 2.6, fx: 2.2, fy: 0 },
      { x: 4, y: 4.7, w: 12, h: 2.6, fx: -1.6, fy: 0 },
      { x: 4, y: 8.4, w: 12, h: 2.6, fx: 2.2, fy: 0 },
    ],
    windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 6, y: 2, r: 0.55 },
      { id: 's2', x: 14, y: 9.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 30, inkUses: 1 },
    boat: { speed: 3.2, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 28, text: '路線長度 ≤ 28 格' },
    ],
    rewards: { coffee: 28, materials: 12 },
    hint: '中間人潮逆住推，行上面或者下面嗰條。',
  },
  {
    id: 'storm_003',
    region: 'storm',
    name: '八號風球',
    tags: ['crosswind', 'precision'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [[
      { x: 8.5, y: 4 }, { x: 11.5, y: 4 }, { x: 13, y: 6 },
      { x: 11.5, y: 8 }, { x: 8.5, y: 8 }, { x: 7, y: 6 },
    ]],
    // 風球側向人潮：左半向下湧、右半向上頂
    windZones: [
      { x: 4, y: 1, w: 6, h: 4, fx: 0, fy: 2.0 },
      { x: 10, y: 5, w: 6, h: 6, fx: 0, fy: -2.0 },
    ],
    currents: [],
    hazards: [
      { x: 6, y: 7, r: 0.7, damage: 45 },
      { x: 13.5, y: 4.5, r: 0.7, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 2.5, r: 0.55 },
      { id: 's2', x: 16.5, y: 8.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 23, text: '路線長度 ≤ 23 格' },
    ],
    rewards: { coffee: 30, materials: 12 },
    hint: '八號風球！側向人潮落雨咁推，穩住。',
  },
  {
    id: 'harbor_008',
    region: 'harbor',
    name: '順路買咖啡',
    tags: ['collect_all', 'precision'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [],
    // 病菌排成菱形閘門
    hazards: [
      { x: 6, y: 6, r: 0.7, damage: 45 },
      { x: 10, y: 2.5, r: 0.7, damage: 45 },
      { x: 10, y: 9.5, r: 0.7, damage: 45 },
      { x: 14, y: 6, r: 0.7, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 2, r: 0.55 },
      { id: 's2', x: 10, y: 6, r: 0.55 },
      { id: 's3', x: 14, y: 10, r: 0.55 },
    ],
    rules: { maxRouteLength: 28, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 3 杯咖啡' },
      { type: 'efficiency', maxLength: 25, text: '路線長度 ≤ 25 格' },
    ],
    rewards: { coffee: 32, materials: 13 },
    hint: '病菌排住隊，三杯咖啡執齊先好返工。',
  },
  {
    id: 'storm_004',
    region: 'storm',
    name: '老細催命',
    tags: ['final', 'vortex_combo', 'precision'],
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 6, y: 2 }, { x: 9, y: 2 }, { x: 9, y: 5 }, { x: 6, y: 5 }],
      [{ x: 11, y: 6 }, { x: 14, y: 6 }, { x: 14, y: 9 }, { x: 11, y: 9 }],
    ],
    // 底部順流快線推送、頂部風球逆風頂住
    currents: [{ x: 3, y: 8, w: 14, h: 3, fx: 2.4, fy: 0 }],
    windZones: [{ x: 10, y: 1, w: 8, h: 4, fx: -1.6, fy: -0.8 }],
    hazards: [
      { x: 6, y: 7, r: 0.7, damage: 45 },
      { x: 13, y: 5.5, r: 0.7, damage: 45 },
      { x: 15.5, y: 1.5, r: 0.7, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 8, y: 8, r: 0.55 },
      { id: 's2', x: 13, y: 3, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 40, materials: 15 },
    hint: '老細每分鐘催一次——最後一關，全部一齊嚟！',
  },

  // ============ 通宵加班（終極篇）============
  // 每關引入一種新「體質」：半體力 → 高速 → 靈敏轉向 → 人潮敏感 → 終極混合
  {
    id: 'harbor_009',
    region: 'harbor',
    name: '輕身上路',
    tags: ['tutorial', 'fragile'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [[
      { x: 8.5, y: 3 }, { x: 11.5, y: 3 }, { x: 13, y: 6 },
      { x: 11.5, y: 9 }, { x: 8.5, y: 9 }, { x: 7, y: 6 },
    ]],
    currents: [], windZones: [],
    // 新元素：體力得一半——病菌一撞就幾乎冇命
    hazards: [
      { x: 13, y: 4, r: 0.7, damage: 45 },
      { x: 13, y: 8, r: 0.7, damage: 45 },
    ],
    collectibles: [{ id: 's1', x: 9, y: 1.8, r: 0.6 }],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.3, durability: 55, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'noCollision', text: '全程不碰撞' },
      { type: 'efficiency', maxLength: 21, text: '路線長度 ≤ 21 格' },
    ],
    rewards: { coffee: 34, materials: 14 },
    hint: '今日體力得一半——掂一掂病菌就差不多冇命，貼住空檔行。',
  },
  {
    id: 'river_004',
    region: 'river',
    name: '快人一步',
    tags: ['speed', 'slalom'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 三個工地交錯排開，高速下上落落穿梭
    terrain: [
      [{ x: 5, y: 0 }, { x: 7, y: 0 }, { x: 7, y: 5 }, { x: 5, y: 5 }],
      [{ x: 9, y: 7 }, { x: 11, y: 7 }, { x: 11, y: 12 }, { x: 9, y: 12 }],
      [{ x: 13, y: 0 }, { x: 15, y: 0 }, { x: 15, y: 5 }, { x: 13, y: 5 }],
    ],
    currents: [], windZones: [], hazards: [],
    // 新元素：速度 4.3——行得快但轉彎要預早
    collectibles: [{ id: 's1', x: 10, y: 3, r: 0.6 }],
    rules: { maxRouteLength: 30, inkUses: 1 },
    boat: { speed: 4.3, durability: 100, turn_resistance: 0.45, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執埋轉彎位咖啡' },
      { type: 'efficiency', maxLength: 27, text: '路線長度 ≤ 27 格' },
    ],
    rewards: { coffee: 36, materials: 15 },
    hint: '呢關快人一步——衝得快，但轉彎記得預早落墨。',
  },
  {
    id: 'harbor_010',
    region: 'harbor',
    name: '食過夜粥',
    tags: ['agile', 'maze'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 三道窄牆閘口（頂、底、頂），病菌守喺閘口邊
    terrain: [
      [{ x: 5, y: 3 }, { x: 6, y: 3 }, { x: 6, y: 12 }, { x: 5, y: 12 }],
      [{ x: 9, y: 0 }, { x: 10, y: 0 }, { x: 10, y: 9 }, { x: 9, y: 9 }],
      [{ x: 13, y: 3 }, { x: 14, y: 3 }, { x: 14, y: 12 }, { x: 13, y: 12 }],
    ],
    currents: [], windZones: [],
    hazards: [
      { x: 5.5, y: 0.2, r: 0.7, damage: 45 },
      { x: 9.5, y: 11.8, r: 0.7, damage: 45 },
      { x: 13.5, y: 0.2, r: 0.7, damage: 45 },
    ],
    // 新元素：轉向極靈敏（0.15）——窄縫窄檔都穿到
    collectibles: [
      { id: 's1', x: 7.5, y: 6, r: 0.55 },
      { id: 's2', x: 11.5, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 44, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.15, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 42, text: '路線長度 ≤ 42 格' },
    ],
    rewards: { coffee: 38, materials: 16 },
    hint: '學過吓功夫轉向快——窄縫窄檔，照樣穿得過。',
  },
  {
    id: 'storm_005',
    region: 'storm',
    name: '人肉乒乓',
    tags: ['wind_hypersensitive', 'chaos'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [],
    // 棋盤格側向人潮：上下左右互相頂撞
    windZones: [
      { x: 4, y: 1, w: 3, h: 5, fx: 1.6, fy: 0 },
      { x: 4, y: 6, w: 3, h: 5, fx: -1.6, fy: 0 },
      { x: 9, y: 1, w: 3, h: 5, fx: -1.6, fy: 0 },
      { x: 9, y: 6, w: 3, h: 5, fx: 1.6, fy: 0 },
      { x: 14, y: 1, w: 3, h: 5, fx: 1.6, fy: 0 },
      { x: 14, y: 6, w: 3, h: 5, fx: -1.6, fy: 0 },
    ],
    hazards: [
      { x: 6, y: 4, r: 0.7, damage: 45 },
      { x: 12, y: 8, r: 0.7, damage: 45 },
    ],
    // 新元素：wind_affinity 1.7——人潮推力放大近倍
    collectibles: [
      { id: 's1', x: 10, y: 2, r: 0.55 },
      { id: 's2', x: 10, y: 10, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1.7 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 29, text: '路線長度 ≤ 29 格' },
    ],
    rewards: { coffee: 42, materials: 18 },
    hint: '而家對人潮特別敏感，俾人推嚟推去——企穩陣腳。',
  },
  {
    id: 'storm_006',
    region: 'storm',
    name: '通宵達旦',
    tags: ['final', 'boss'],
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    // 三重鋸齒工地：底閘、頂閘、底閘
    terrain: [
      [{ x: 5, y: 0 }, { x: 7, y: 0 }, { x: 7, y: 7 }, { x: 5, y: 7 }],
      [{ x: 10, y: 4 }, { x: 12, y: 4 }, { x: 12, y: 12 }, { x: 10, y: 12 }],
      [{ x: 14.5, y: 0 }, { x: 16.5, y: 0 }, { x: 16.5, y: 7 }, { x: 14.5, y: 7 }],
    ],
    // 底部順流快線、頂部風球逆風
    currents: [{ x: 3, y: 8.5, w: 15, h: 2.5, fx: 2.0, fy: 0 }],
    windZones: [{ x: 8, y: 1, w: 10, h: 3.5, fx: -1.5, fy: -0.6 }],
    hazards: [
      { x: 6.5, y: 8, r: 0.7, damage: 45 },
      { x: 11, y: 0.8, r: 0.7, damage: 45 },
      { x: 15.8, y: 6.5, r: 0.7, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 5, y: 9.5, r: 0.55 },
      { id: 's2', x: 13, y: 2.5, r: 0.55 },
      { id: 's3', x: 16.5, y: 10, r: 0.55 },
    ],
    // 終極體質：快（3.8）＋脆（60）
    rules: { maxRouteLength: 38, inkUses: 1 },
    boat: { speed: 3.8, durability: 60, turn_resistance: 0.3, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 3 杯咖啡' },
      { type: 'efficiency', maxLength: 36, text: '路線長度 ≤ 36 格' },
    ],
    rewards: { coffee: 50, materials: 20 },
    hint: '通宵都要返到公司——速度、體力、人潮、病菌，終極一戰！',
  },

  // ============ 返工地獄輪迴（21-30）============
  // 新引擎元素：擺動人潮帶（osc）→ 紅綠燈病菌（period）→ 夜間主題 → 巡邏病菌（patrol）
  {
    id: 'harbor_011',
    region: 'harbor',
    name: '飄忽人潮',
    tags: ['tutorial', 'osc'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 新元素：人潮帶上下飄移（osc）
    currents: [
      { x: 6, y: 5, w: 9, h: 2.4, fx: 2.4, fy: 0, osc: { amp: 1.6, speed: 1.2 } },
    ],
    windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 12, y: 3, r: 0.6 }],
    rules: { maxRouteLength: 22, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執埋人潮邊咖啡' },
      { type: 'efficiency', maxLength: 19, text: '路線長度 ≤ 19 格' },
    ],
    rewards: { coffee: 44, materials: 18 },
    hint: '人潮帶會上下飄——佢推你一把，但位置唔定。',
  },
  {
    id: 'river_005',
    region: 'river',
    name: '左右為難',
    tags: ['osc', 'precision'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [[
      { x: 8.5, y: 5 }, { x: 11.5, y: 5 }, { x: 13, y: 7 },
      { x: 11.5, y: 9 }, { x: 8.5, y: 9 }, { x: 7, y: 7 },
    ]],
    // 兩條相反飄移人潮帶：上帶順推、下帶逆頂（相位相反）
    currents: [
      { x: 4, y: 2, w: 12, h: 2.2, fx: 2.2, fy: 0, osc: { amp: 2.2, speed: 1.5 } },
      { x: 4, y: 8, w: 12, h: 2.2, fx: -1.8, fy: 0, osc: { amp: 2.2, speed: 1.5, phase: Math.PI } },
    ],
    windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 10, y: 2.5, r: 0.55 },
      { id: 's2', x: 16, y: 8.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 46, materials: 18 },
    hint: '上帶順推、下帶逆頂，兩條都喺度飄——揀啱時機。',
  },
  {
    id: 'storm_007',
    region: 'storm',
    name: '紅綠燈口',
    tags: ['tutorial', 'traffic_light'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 上下牆收窄成走廊，病菌喺走廊內亮燈／熄燈
    terrain: [
      [{ x: 6, y: 0 }, { x: 14, y: 0 }, { x: 14, y: 4 }, { x: 6, y: 4 }],
      [{ x: 6, y: 8 }, { x: 14, y: 8 }, { x: 14, y: 12 }, { x: 6, y: 12 }],
    ],
    currents: [], windZones: [],
    // 新元素：紅綠燈病菌——熄燈（淡化）時可安全通過
    hazards: [
      { x: 8, y: 6, r: 0.65, damage: 30, period: 3 },
      { x: 12, y: 6, r: 0.65, damage: 30, period: 3, phase: 1.5 },
    ],
    collectibles: [{ id: 's1', x: 10, y: 6, r: 0.6 }],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執走廊中間咖啡' },
      { type: 'efficiency', maxLength: 18, text: '路線長度 ≤ 18 格' },
    ],
    rewards: { coffee: 48, materials: 19 },
    hint: '紅燈病菌會熄燈——睇準時機直線衝過去！',
  },
  {
    id: 'river_006',
    region: 'river',
    name: '衝燈博一搏',
    tags: ['traffic_light', 'risk'],
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 5, y: 3 }, { x: 12, y: 3 }, { x: 12, y: 7 }, { x: 5, y: 7 }],
    ],
    currents: [], windZones: [],
    hazards: [
      { x: 13, y: 5, r: 0.65, damage: 30, period: 2.5 },
      { x: 13, y: 9.5, r: 0.65, damage: 30, period: 2.5, phase: 1.25 },
      { x: 16, y: 3, r: 0.65, damage: 30, period: 2, phase: 0.5 },
    ],
    collectibles: [
      { id: 's1', x: 8, y: 9.5, r: 0.55 },
      { id: 's2', x: 15, y: 3.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 25, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 50, materials: 19 },
    hint: '衝燈博一搏——病菌熄燈嗰陣衝過去！',
  },
  {
    id: 'storm_008',
    region: 'storm',
    name: '夜更返工',
    tags: ['tutorial', 'night'],
    theme: 'night',
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 深夜通道：上下兩塊巨牆，中間窄走廊
    terrain: [
      [{ x: 7, y: 1 }, { x: 10, y: 1 }, { x: 10, y: 4.5 }, { x: 7, y: 4.5 }],
      [{ x: 10, y: 7.5 }, { x: 13, y: 7.5 }, { x: 13, y: 11 }, { x: 10, y: 11 }],
    ],
    // 夜間微風順推
    currents: [{ x: 4, y: 4.5, w: 12, h: 3, fx: 1.2, fy: 0 }],
    windZones: [],
    hazards: [
      { x: 5, y: 2.5, r: 0.65, damage: 45 },
      { x: 15, y: 9.5, r: 0.65, damage: 45 },
    ],
    collectibles: [{ id: 's1', x: 10, y: 6, r: 0.6 }],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執通道中心咖啡' },
      { type: 'efficiency', maxLength: 17, text: '路線長度 ≤ 17 格' },
    ],
    rewards: { coffee: 52, materials: 20 },
    hint: '夜更開工——街燈照住條路，睇清楚先行。',
  },
  {
    id: 'harbor_012',
    region: 'harbor',
    name: '深宵趕路',
    tags: ['night', 'precision'],
    theme: 'night',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 5, y: 5 }, { x: 8, y: 5 }, { x: 8, y: 9 }, { x: 5, y: 9 }],
      [{ x: 11, y: 2.2 }, { x: 14, y: 2.2 }, { x: 14, y: 5 }, { x: 11, y: 5 }],
    ],
    // 底部順流、頂部逆風
    currents: [{ x: 3, y: 8, w: 13, h: 3, fx: 1.8, fy: 0 }],
    windZones: [{ x: 10, y: 1, w: 8, h: 3, fx: -1.2, fy: 0 }],
    hazards: [
      { x: 4, y: 7, r: 0.65, damage: 45 },
      { x: 12.5, y: 8.5, r: 0.65, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 9.5, y: 8, r: 0.55 },
      { id: 's2', x: 16, y: 6.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 28, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 25, text: '路線長度 ≤ 25 格' },
    ],
    rewards: { coffee: 54, materials: 20 },
    hint: '深宵趕路——底順頂逆，貼住燈光行。',
  },
  {
    id: 'river_007',
    region: 'river',
    name: '巡邏病菌',
    tags: ['tutorial', 'patrol'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [],
    // 新元素：巡邏病菌——垂直往返移動
    hazards: [
      { x: 7, y: 6, r: 0.65, damage: 30, patrol: { x0: 7, y0: 3, x1: 7, y1: 9, speed: 1.2 } },
      { x: 13, y: 6, r: 0.65, damage: 30, patrol: { x0: 13, y0: 9, x1: 13, y1: 3, speed: 1.2 } },
    ],
    collectibles: [{ id: 's1', x: 10, y: 6, r: 0.6 }],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執兩菌之間咖啡' },
      { type: 'efficiency', maxLength: 17, text: '路線長度 ≤ 17 格' },
    ],
    rewards: { coffee: 56, materials: 21 },
    hint: '病菌周圍巡——睇佢行開嗰陣先過！',
  },
  {
    id: 'storm_009',
    region: 'storm',
    name: '擺脫病菌',
    tags: ['patrol', 'maze'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    // 中央牆留窄閘（y4.5-7.5），左右巡邏病菌守閘
    terrain: [
      [{ x: 9, y: 0 }, { x: 11, y: 0 }, { x: 11, y: 4.5 }, { x: 9, y: 4.5 }],
      [{ x: 9, y: 7.5 }, { x: 11, y: 7.5 }, { x: 11, y: 12 }, { x: 9, y: 12 }],
    ],
    currents: [], windZones: [],
    hazards: [
      { x: 6, y: 6, r: 0.65, damage: 30, patrol: { x0: 4, y0: 6, x1: 8, y1: 6, speed: 1.5 } },
      { x: 14, y: 6, r: 0.65, damage: 30, patrol: { x0: 16, y0: 6, x1: 12, y1: 6, speed: 1.5 } },
      { x: 5, y: 8, r: 0.65, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 5, y: 4, r: 0.55 },
      { id: 's2', x: 16, y: 8, r: 0.55 },
    ],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 20, text: '路線長度 ≤ 20 格' },
    ],
    rewards: { coffee: 58, materials: 21 },
    hint: '病菌左右咁巡——窄閘窄縫，睇路！',
  },
  {
    id: 'storm_010',
    region: 'storm',
    name: '返工馬拉松',
    tags: ['marathon', 'maze'],
    start: { x: 1.5, y: 10 },
    destinations: [{ id: 'home_01', x: 18.5, y: 2, r: 1.1 }],
    // 四重閘口蛇形迷宮（底、頂、底、頂）
    terrain: [
      [{ x: 3, y: 0 }, { x: 5, y: 0 }, { x: 5, y: 7 }, { x: 3, y: 7 }],
      [{ x: 7, y: 4 }, { x: 9, y: 4 }, { x: 9, y: 12 }, { x: 7, y: 12 }],
      [{ x: 11, y: 0 }, { x: 13, y: 0 }, { x: 13, y: 7 }, { x: 11, y: 7 }],
      [{ x: 15, y: 4 }, { x: 17, y: 4 }, { x: 17, y: 12 }, { x: 15, y: 12 }],
    ],
    // 上下順流帶助跑
    currents: [
      { x: 5, y: 1, w: 14, h: 2.5, fx: 1.4, fy: 0 },
      { x: 5, y: 8.5, w: 14, h: 2.5, fx: 1.4, fy: 0 },
    ],
    windZones: [],
    hazards: [
      { x: 10, y: 6, r: 0.6, damage: 30, patrol: { x0: 10, y0: 4, x1: 10, y1: 8, speed: 1.2 } },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 6, r: 0.55 },
      { id: 's2', x: 10, y: 3, r: 0.55 },
      { id: 's3', x: 14, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 42, inkUses: 1 },
    boat: { speed: 3.4, durability: 100, turn_resistance: 0.35, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 3 杯回氣咖啡' },
      { type: 'efficiency', maxLength: 40, text: '路線長度 ≤ 40 格' },
    ],
    rewards: { coffee: 64, materials: 24 },
    hint: '長途馬拉松——四重閘口上上落落，中途執咖啡回氣！',
  },
  {
    id: 'storm_011',
    region: 'storm',
    name: '地獄輪迴',
    tags: ['final', 'boss', 'night'],
    theme: 'night',
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [
      [{ x: 8, y: 4 }, { x: 12, y: 4 }, { x: 12, y: 8 }, { x: 8, y: 8 }],
    ],
    // 擺動人潮上下夾擊（相位相反）
    currents: [
      { x: 4, y: 2, w: 12, h: 2.2, fx: 2.0, fy: 0, osc: { amp: 1.4, speed: 1.3 } },
      { x: 4, y: 8, w: 12, h: 2.2, fx: -1.6, fy: 0, osc: { amp: 1.4, speed: 1.3, phase: 1.5 } },
    ],
    windZones: [],
    // 巡邏＋紅綠燈病菌齊發
    hazards: [
      { x: 6, y: 3.4, r: 0.65, damage: 30, patrol: { x0: 5, y0: 3.4, x1: 9, y1: 3.4, speed: 1.6 } },
      { x: 12.5, y: 10, r: 0.65, damage: 30, patrol: { x0: 10.5, y0: 10, x1: 13.5, y1: 10, speed: 1.6 } },
      { x: 10, y: 3, r: 0.6, damage: 30, period: 2.4 },
      { x: 10, y: 9, r: 0.6, damage: 30, period: 2.4, phase: 1.2 },
    ],
    collectibles: [
      { id: 's1', x: 10, y: 1.2, r: 0.55 },
      { id: 's2', x: 15.5, y: 10.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.5, durability: 80, turn_resistance: 0.35, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 29, text: '路線長度 ≤ 29 格' },
    ],
    rewards: { coffee: 80, materials: 28 },
    hint: '最終輪迴——黑夜、亂流、巡邏病菌，全部一次過！',
  },

  // ============ 病菌大爆發（31-35）============
  // 新元素：分裂病菌（split）→ 疫苗體質（wind_affinity 0.3）→ 終極混合
  {
    id: 'river_008',
    region: 'river',
    name: '打咗疫苗',
    tags: ['tutorial', 'vaccine'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [
      [{ x: 8, y: 4 }, { x: 12, y: 4 }, { x: 12, y: 8 }, { x: 8, y: 8 }],
    ],
    // 強力側向人潮（正常會吹到飛起）
    windZones: [
      { x: 3, y: 1, w: 14, h: 4, fx: 0, fy: 2.6 },
      { x: 3, y: 7, w: 14, h: 4, fx: 0, fy: -2.6 },
    ],
    currents: [],
    hazards: [
      { x: 4.5, y: 4.5, r: 0.65, damage: 45 },
      { x: 4.5, y: 7.5, r: 0.65, damage: 45 },
      { x: 14, y: 7.5, r: 0.65, damage: 45 },
    ],
    // 新體質：wind_affinity 0.3——側向人潮推極都推唔郁
    collectibles: [
      { id: 's1', x: 6.5, y: 2.2, r: 0.55 },
      { id: 's2', x: 6.5, y: 9.8, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 0.3 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 29, text: '路線長度 ≤ 29 格' },
    ],
    rewards: { coffee: 70, materials: 24 },
    hint: '打咗疫苗——側向人潮推極都推唔郁你，照衝！',
  },
  {
    id: 'harbor_013',
    region: 'harbor',
    name: '病菌溫床',
    tags: ['tutorial', 'split'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 溫和順推人潮
    currents: [{ x: 4, y: 4, w: 12, h: 4, fx: 1.0, fy: 0 }],
    windZones: [],
    // 新元素：大舊分裂病菌——一撞變兩舊細菌
    hazards: [
      { x: 10, y: 6, r: 0.85, damage: 35, split: { maxGen: 1 } },
    ],
    collectibles: [
      { id: 's1', x: 10, y: 2.5, r: 0.55 },
      { id: 's2', x: 14, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 22, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 19, text: '路線長度 ≤ 19 格' },
    ],
    rewards: { coffee: 74, materials: 25 },
    hint: '嗰舊大病菌會分裂——一撞變兩舊，唔好掂佢！',
  },
  {
    id: 'storm_012',
    region: 'storm',
    name: '變種病菌',
    tags: ['split', 'patrol'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [],
    currents: [],
    // 斜向側推
    windZones: [{ x: 4, y: 3, w: 12, h: 6, fx: 0.4, fy: 1.2 }],
    // 兩舊巡邏分裂病菌
    hazards: [
      { x: 7, y: 4, r: 0.8, damage: 35, split: { maxGen: 1 }, patrol: { x0: 5, y0: 4, x1: 9, y1: 4, speed: 1.2 } },
      { x: 13, y: 8, r: 0.8, damage: 35, split: { maxGen: 1 }, patrol: { x0: 11, y0: 8, x1: 15, y1: 8, speed: 1.2 } },
    ],
    collectibles: [
      { id: 's1', x: 7, y: 6, r: 0.55 },
      { id: 's2', x: 13, y: 10, r: 0.55 },
    ],
    rules: { maxRouteLength: 28, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 25, text: '路線長度 ≤ 25 格' },
    ],
    rewards: { coffee: 78, materials: 26 },
    hint: '變種病菌四圍走仲識分裂——遠遠行開！',
  },
  {
    id: 'storm_013',
    region: 'storm',
    name: '疫症爆發',
    tags: ['split', 'night'],
    theme: 'night',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 8, y: 3 }, { x: 11, y: 3 }, { x: 11, y: 7 }, { x: 8, y: 7 }],
    ],
    currents: [{ x: 3, y: 8, w: 14, h: 3, fx: 1.6, fy: 0 }],
    windZones: [{ x: 10, y: 1, w: 8, h: 3, fx: -1.2, fy: -0.6 }],
    // 三舊分裂病菌散布
    hazards: [
      { x: 6, y: 6, r: 0.8, damage: 35, split: { maxGen: 1 } },
      { x: 13, y: 8, r: 0.8, damage: 35, split: { maxGen: 1 } },
      { x: 15, y: 4, r: 0.8, damage: 35, split: { maxGen: 1 } },
    ],
    collectibles: [
      { id: 's1', x: 5, y: 9.5, r: 0.55 },
      { id: 's2', x: 17, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 84, materials: 28 },
    hint: '疫症夜間爆發——大舊病菌周圍都係，貼燈光閃。',
  },
  {
    id: 'storm_014',
    region: 'storm',
    name: '終極帶菌者',
    tags: ['final', 'boss', 'split', 'night'],
    theme: 'night',
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [
      [{ x: 6, y: 3 }, { x: 9, y: 3 }, { x: 9, y: 7 }, { x: 6, y: 7 }],
      [{ x: 11, y: 5 }, { x: 14, y: 5 }, { x: 14, y: 9 }, { x: 11, y: 9 }],
    ],
    // 擺動人潮上下夾擊
    currents: [
      { x: 4, y: 2, w: 12, h: 2, fx: 1.8, fy: 0, osc: { amp: 1.2, speed: 1.4 } },
      { x: 4, y: 8, w: 12, h: 2, fx: -1.4, fy: 0, osc: { amp: 1.2, speed: 1.4, phase: 1.5 } },
    ],
    windZones: [],
    hazards: [
      { x: 16, y: 6, r: 0.85, damage: 35, split: { maxGen: 1 } },
      { x: 10, y: 8.5, r: 0.6, damage: 25, patrol: { x0: 10, y0: 8.5, x1: 10, y1: 3.5, speed: 1.6 } },
      { x: 10, y: 1.5, r: 0.6, damage: 25, period: 2.2 },
    ],
    collectibles: [
      { id: 's1', x: 5, y: 2, r: 0.55 },
      { id: 's2', x: 15, y: 2.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.6, durability: 75, turn_resistance: 0.32, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 100, materials: 32 },
    hint: '終極帶菌者——黑夜亂流兼分裂病菌，最後衝刺！',
  },

  // ============ 風雨不改（36-45）============
  // 新元素：緊迫限時（rules.timeLimit）→ 颱風主題（雨絲＋閃電）→ 反向起點 → 終極混合
  {
    id: 'harbor_014',
    region: 'harbor',
    name: '最後一分鐘',
    tags: ['tutorial', 'time_pressure'],
    theme: 'night',
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 10, y: 6, r: 0.6 }],
    // 新元素：限時 14 秒——遲起床極速衝刺
    rules: { maxRouteLength: 20, inkUses: 1, timeLimit: 14 },
    boat: { speed: 3.6, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '順路執杯咖啡' },
      { type: 'efficiency', maxLength: 17, text: '路線長度 ≤ 17 格' },
    ],
    rewards: { coffee: 90, materials: 30 },
    hint: '剩返一分鐘！14 秒內衝到公司——唔好有任何懸念！',
  },
  {
    id: 'harbor_015',
    region: 'harbor',
    name: '遲過返曬工',
    tags: ['time_pressure', 'maze'],
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 6, y: 4 }, { x: 10, y: 4 }, { x: 10, y: 8 }, { x: 6, y: 8 }],
    ],
    currents: [{ x: 4, y: 8, w: 12, h: 2.5, fx: 1.4, fy: 0 }],
    windZones: [],
    hazards: [
      { x: 13, y: 6, r: 0.65, damage: 30 },
      { x: 6, y: 2, r: 0.65, damage: 30 },
    ],
    collectibles: [
      { id: 's1', x: 12, y: 10, r: 0.55 },
      { id: 's2', x: 16, y: 4, r: 0.55 },
    ],
    // 更緊：12 秒
    rules: { maxRouteLength: 26, inkUses: 1, timeLimit: 12 },
    boat: { speed: 3.7, durability: 100, turn_resistance: 0.35, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 94, materials: 30 },
    hint: '12 秒！全公司淨係你未到——拐彎抹角都係要快！',
  },
  {
    id: 'river_009',
    region: 'river',
    name: '黑雨警告',
    tags: ['tutorial', 'typhoon'],
    theme: 'typhoon',
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 12, y: 3, r: 0.6 }],
    rules: { maxRouteLength: 22, inkUses: 1 },
    boat: { speed: 3.4, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '雨中執咖啡' },
      { type: 'efficiency', maxLength: 19, text: '路線長度 ≤ 19 格' },
    ],
    rewards: { coffee: 98, materials: 32 },
    hint: '黑雨都照返工——斜風細雨，睇清楚條路。',
  },
  {
    id: 'storm_015',
    region: 'storm',
    name: '三號風球',
    tags: ['typhoon', 'osc'],
    theme: 'typhoon',
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [[
      { x: 8.5, y: 4 }, { x: 11.5, y: 4 }, { x: 13, y: 7 },
      { x: 11.5, y: 10 }, { x: 8.5, y: 10 }, { x: 7, y: 7 },
    ]],
    // 颱風側推＋擺動人潮
    windZones: [{ x: 3, y: 5, w: 14, h: 4, fx: 0.5, fy: 1.8 }],
    currents: [
      { x: 4, y: 1.5, w: 12, h: 2, fx: 2.0, fy: 0, osc: { amp: 1.2, speed: 1.3 } },
    ],
    hazards: [
      { x: 6, y: 8, r: 0.65, damage: 30 },
      { x: 14, y: 3, r: 0.65, damage: 30 },
    ],
    collectibles: [
      { id: 's1', x: 10, y: 1.5, r: 0.55 },
      { id: 's2', x: 16, y: 8.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.4, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 102, materials: 32 },
    hint: '三號風球——雨中擺動人潮，望清楚先落腳。',
  },
  {
    id: 'storm_016',
    region: 'storm',
    name: '八號波返工',
    tags: ['typhoon', 'split', 'night'],
    theme: 'typhoon',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 7, y: 3 }, { x: 10, y: 3 }, { x: 10, y: 7 }, { x: 7, y: 7 }],
    ],
    currents: [{ x: 3, y: 8, w: 13, h: 3, fx: 1.8, fy: 0 }],
    windZones: [{ x: 10, y: 1, w: 8, h: 3, fx: -1.4, fy: -0.7 }],
    hazards: [
      { x: 13, y: 8, r: 0.8, damage: 35, split: { maxGen: 1 } },
      { x: 15, y: 5, r: 0.65, damage: 30 },
    ],
    collectibles: [
      { id: 's1', x: 5, y: 9.5, r: 0.55 },
      { id: 's2', x: 12, y: 1.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.4, durability: 90, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 20, text: '路線長度 ≤ 20 格' },
    ],
    rewards: { coffee: 106, materials: 34 },
    hint: '八號波都要返工——黑雨閃電分裂菌，貼穩條路。',
  },
  {
    id: 'harbor_016',
    region: 'harbor',
    name: '掉頭返屋企',
    tags: ['reverse', 'tutorial'],
    start: { x: 18, y: 6 },
    destinations: [{ id: 'home_01', x: 2, y: 6, r: 1.1 }],
    terrain: [[
      { x: 8.5, y: 3 }, { x: 11.5, y: 3 }, { x: 13, y: 6 },
      { x: 11.5, y: 9 }, { x: 8.5, y: 9 }, { x: 7, y: 6 },
    ]],
    // 新元素：反向起點——起點喺右（公司側）、屋企喺左
    currents: [], windZones: [],
    hazards: [
      { x: 6, y: 3.5, r: 0.65, damage: 30 },
      { x: 6, y: 8.5, r: 0.65, damage: 30 },
    ],
    collectibles: [{ id: 's1', x: 10, y: 1.5, r: 0.6 }],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執中央咖啡' },
      { type: 'efficiency', maxLength: 21, text: '路線長度 ≤ 21 格' },
    ],
    rewards: { coffee: 110, materials: 34 },
    hint: '掉頭返屋企攞嘢——起點變咗右邊，方向掉轉嚟諗！',
  },
  {
    id: 'river_010',
    region: 'river',
    name: '逆流返工路',
    tags: ['reverse', 'currents'],
    start: { x: 18, y: 10 },
    destinations: [{ id: 'home_01', x: 2, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 5, y: 1 }, { x: 8, y: 1 }, { x: 8, y: 5 }, { x: 5, y: 5 }],
      [{ x: 11, y: 7 }, { x: 14, y: 7 }, { x: 14, y: 11 }, { x: 11, y: 11 }],
    ],
    // 反向快線：向西推（與趕路方向相反＝逆流）
    currents: [{ x: 3, y: 5, w: 14, h: 2, fx: -2.2, fy: 0 }],
    windZones: [],
    hazards: [
      { x: 16, y: 5, r: 0.65, damage: 30 },
      { x: 6, y: 8, r: 0.65, damage: 30 },
    ],
    collectibles: [
      { id: 's1', x: 16, y: 8.5, r: 0.55 },
      { id: 's2', x: 12, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 34, inkUses: 1 },
    boat: { speed: 3.5, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 30, text: '路線長度 ≤ 30 格' },
    ],
    rewards: { coffee: 114, materials: 36 },
    hint: '逆流而上——成條快線逆住你推，攞盡角度！',
  },
  {
    id: 'storm_017',
    region: 'storm',
    name: '十號風球',
    tags: ['typhoon', 'chaos', 'osc'],
    theme: 'typhoon',
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 颱風十字陣：上下左右四股強力人潮
    windZones: [
      { x: 4, y: 1, w: 12, h: 4, fx: 0, fy: 2.6 },
      { x: 4, y: 7, w: 12, h: 4, fx: 0, fy: -2.6 },
    ],
    currents: [
      { x: 4, y: 5, w: 6, h: 2, fx: 2.4, fy: 0, osc: { amp: 1.6, speed: 1.5 } },
      { x: 12, y: 5, w: 5, h: 2, fx: -1.8, fy: 0, osc: { amp: 1.6, speed: 1.5, phase: 1.5 } },
    ],
    hazards: [
      { x: 10, y: 2, r: 0.65, damage: 30, patrol: { x0: 8, y0: 2, x1: 12, y1: 2, speed: 1.6 } },
      { x: 10, y: 10, r: 0.65, damage: 30, patrol: { x0: 12, y0: 10, x1: 8, y1: 10, speed: 1.6 } },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 6, r: 0.55 },
      { id: 's2', x: 15, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.5, durability: 90, turn_resistance: 0.35, wind_affinity: 0.6 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 20, text: '路線長度 ≤ 20 格' },
    ],
    rewards: { coffee: 120, materials: 38 },
    hint: '十號風球！十字颱風陣——捉緊每個空檔！',
  },
  {
    id: 'harbor_017',
    region: 'harbor',
    name: '午飯衝刺',
    tags: ['time_pressure', 'collect'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [{ x: 4, y: 4, w: 12, h: 4, fx: 1.6, fy: 0 }],
    windZones: [],
    hazards: [
      { x: 8, y: 2.5, r: 0.6, damage: 25 },
      { x: 8, y: 9.5, r: 0.6, damage: 25 },
      { x: 14, y: 2.5, r: 0.6, damage: 25 },
      { x: 14, y: 9.5, r: 0.6, damage: 25 },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 6, r: 0.55 },
      { id: 's2', x: 11, y: 6, r: 0.55 },
      { id: 's3', x: 16, y: 6, r: 0.55 },
    ],
    // 午飯限定：16 秒執齊 3 杯
    rules: { maxRouteLength: 22, inkUses: 1, timeLimit: 16 },
    boat: { speed: 3.6, durability: 100, turn_resistance: 0.35, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 3 杯午餐咖啡' },
      { type: 'efficiency', maxLength: 19, text: '路線長度 ≤ 19 格' },
    ],
    rewards: { coffee: 126, materials: 40 },
    hint: '午飯衝刺——16 秒順手執 3 杯咖啡返寫字樓！',
  },
  {
    id: 'river_011',
    region: 'river',
    name: 'OT 惡夢',
    tags: ['time_pressure', 'maze', 'night'],
    theme: 'night',
    start: { x: 1.5, y: 6 },
    destinations: [{ id: 'home_01', x: 18.5, y: 6, r: 1.1 }],
    // OT 惡夢迷宮：上下窄牆交錯
    terrain: [
      [{ x: 4, y: 0 }, { x: 6, y: 0 }, { x: 6, y: 8 }, { x: 4, y: 8 }],
      [{ x: 9, y: 4 }, { x: 11, y: 4 }, { x: 11, y: 12 }, { x: 9, y: 12 }],
      [{ x: 14, y: 0 }, { x: 16, y: 0 }, { x: 16, y: 8 }, { x: 14, y: 8 }],
    ],
    currents: [], windZones: [],
    hazards: [
      { x: 7.5, y: 10, r: 0.6, damage: 25 },
      { x: 12.5, y: 2, r: 0.6, damage: 25 },
    ],
    collectibles: [
      { id: 's1', x: 7.5, y: 2, r: 0.55 },
      { id: 's2', x: 12.5, y: 10, r: 0.55 },
    ],
    // 22 秒走完迷宮
    rules: { maxRouteLength: 44, inkUses: 1, timeLimit: 22 },
    boat: { speed: 3.7, durability: 100, turn_resistance: 0.3, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯提神咖啡' },
      { type: 'efficiency', maxLength: 42, text: '路線長度 ≤ 42 格' },
    ],
    rewards: { coffee: 132, materials: 42 },
    hint: 'OT 到夜晚——22 秒穿梭迷宮，執埋咖啡提神！',
  },
  {
    id: 'storm_018',
    region: 'storm',
    name: '風雨不改',
    tags: ['final', 'boss', 'typhoon', 'time_pressure'],
    theme: 'typhoon',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [
      [{ x: 5, y: 2 }, { x: 8, y: 2 }, { x: 8, y: 5 }, { x: 5, y: 5 }],
      [{ x: 12, y: 7 }, { x: 15, y: 7 }, { x: 15, y: 10 }, { x: 12, y: 10 }],
    ],
    // 颱風全開：底順流＋頂逆風＋擺動人潮
    currents: [
      { x: 3, y: 8, w: 14, h: 2.5, fx: 2.0, fy: 0 },
      { x: 8, y: 1, w: 10, h: 2, fx: -1.6, fy: 0, osc: { amp: 1.2, speed: 1.4 } },
    ],
    windZones: [{ x: 6, y: 3, w: 10, h: 4, fx: 0.6, fy: -1.8 }],
    hazards: [
      { x: 10, y: 5.5, r: 0.8, damage: 35, split: { maxGen: 1 } },
      { x: 16, y: 5, r: 0.6, damage: 30, patrol: { x0: 15, y0: 5, x1: 17, y1: 5, speed: 1.8 } },
    ],
    collectibles: [
      { id: 's1', x: 6, y: 9.5, r: 0.55 },
      { id: 's2', x: 13, y: 2.5, r: 0.55 },
    ],
    // 終極限時：20 秒風雨全開
    rules: { maxRouteLength: 30, inkUses: 1, timeLimit: 20 },
    boat: { speed: 3.8, durability: 80, turn_resistance: 0.3, wind_affinity: 0.8 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 26, text: '路線長度 ≤ 26 格' },
    ],
    rewards: { coffee: 150, materials: 48 },
    hint: '風雨不改——十號波都好，20 秒內返到公司！',
  },

  // ============ 通勤煉獄（47-56）============
  // 新元素：迴旋人潮（vortex）→ 凍檸茶補給（heal 回體力）→ 油漬區（oil 轉向失靈）→ 彈彈椅（bumper 彈開不扣血）
  {
    id: 'river_012',
    region: 'river',
    name: '旋轉門',
    tags: ['tutorial', 'vortex'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 新元素：兩個迴旋人潮（上順下逆）
    currents: [
      { vortex: { cx: 8, cy: 3.2, r: 2.4, s: 2.2 } },
      { vortex: { cx: 12, cy: 8.8, r: 2.4, s: -2.2 } },
    ],
    windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 10, y: 6, r: 0.6 }],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執兩個漩渦之間咖啡' },
      { type: 'efficiency', maxLength: 17, text: '路線長度 ≤ 17 格' },
    ],
    rewards: { coffee: 108, materials: 36 },
    hint: '人潮圍住打轉——貼住圓圈邊緣行就唔會被捲入。',
  },
  {
    id: 'harbor_018',
    region: 'harbor',
    name: '陀螺人潮',
    tags: ['vortex', 'precision'],
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [],
    // 中央巨型陀螺
    currents: [{ vortex: { cx: 10, cy: 6, r: 3.4, s: 2.6 } }],
    windZones: [],
    hazards: [],
    collectibles: [{ id: 's1', x: 10, y: 1.8, r: 0.55 }],
    rules: { maxRouteLength: 25, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執陀螺頂咖啡' },
      { type: 'efficiency', maxLength: 23, text: '路線長度 ≤ 23 格' },
    ],
    rewards: { coffee: 112, materials: 38 },
    hint: '中央巨型陀螺——沿住外圍弧線行，千祈唔好直衝。',
  },
  {
    id: 'river_013',
    region: 'river',
    name: '凍檸茶加油站',
    tags: ['tutorial', 'heal'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [],
    // 三道病菌牆（頂隙／底隙／頂隙穿梭）
    hazards: [
      { x: 7, y: 2, r: 0.65, damage: 45 },
      { x: 7, y: 4.5, r: 0.65, damage: 45 },
      { x: 7, y: 7, r: 0.65, damage: 45 },
      { x: 7, y: 9.5, r: 0.65, damage: 45 },
      { x: 12, y: 3.5, r: 0.65, damage: 45 },
      { x: 12, y: 6, r: 0.65, damage: 45 },
      { x: 12, y: 8.5, r: 0.65, damage: 45 },
      { x: 15, y: 2, r: 0.65, damage: 45 },
      { x: 15, y: 4.5, r: 0.65, damage: 45 },
      { x: 15, y: 7, r: 0.65, damage: 45 },
      { x: 15, y: 9.5, r: 0.65, damage: 45 },
    ],
    // 新元素：凍檸茶補給（回體力）——體力只有 50，要靠補給續命（沿頂走廊）
    collectibles: [
      { id: 'h1', x: 9.5, y: 1.0, r: 0.55, heal: 30 },
      { id: 'h2', x: 13.5, y: 1.0, r: 0.55, heal: 30 },
      { id: 'h3', x: 17, y: 1.0, r: 0.55, heal: 30 },
    ],
    rules: { maxRouteLength: 24, inkUses: 1 },
    boat: { speed: 3.3, durability: 50, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '飲齊 3 杯凍檸茶' },
      { type: 'efficiency', maxLength: 22, text: '路線長度 ≤ 22 格' },
    ],
    rewards: { coffee: 116, materials: 40 },
    hint: '體力得一半——沿途飲凍檸茶補血，頂隙底隙咁穿梭！',
  },
  {
    id: 'harbor_019',
    region: 'harbor',
    name: '帶傷上陣',
    tags: ['heal', 'split'],
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    // 中央工地牆（頂隙 y<3、底隙 y>9）
    terrain: [[{ x: 7, y: 3 }, { x: 9, y: 3 }, { x: 9, y: 9 }, { x: 7, y: 9 }]],
    currents: [], windZones: [],
    hazards: [
      { x: 10, y: 6, r: 0.85, damage: 35, split: { maxGen: 1 } },
      { x: 14, y: 5.5, r: 0.6, damage: 30, patrol: { x0: 14, y0: 2.5, x1: 14, y1: 8, speed: 1.4 } },
    ],
    collectibles: [
      { id: 'h1', x: 5, y: 9.8, r: 0.55, heal: 30 },
      { id: 'h2', x: 15.5, y: 9.6, r: 0.55, heal: 30 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 45, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '飲齊 2 杯凍檸茶' },
      { type: 'efficiency', maxLength: 23, text: '路線長度 ≤ 23 格' },
    ],
    rewards: { coffee: 120, materials: 40 },
    hint: '帶傷上陣——體力得 45，分裂病菌同巡邏病菌夾擊，靠凍檸茶續命！',
  },
  {
    id: 'storm_020',
    region: 'storm',
    name: '油漬滿地',
    tags: ['tutorial', 'oil'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 兩塊工地：左塊封頂（底隙）、右塊封底（頂隙）
    terrain: [
      [{ x: 5.5, y: 0 }, { x: 7.5, y: 0 }, { x: 7.5, y: 7 }, { x: 5.5, y: 7 }],
      [{ x: 11, y: 5 }, { x: 13, y: 5 }, { x: 13, y: 12 }, { x: 11, y: 12 }],
    ],
    // 新元素：油漬區——入面轉向近乎失靈
    oilZones: [{ x: 4, y: 3, w: 12, h: 6 }],
    currents: [], windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 9, y: 6, r: 0.55 }],
    rules: { maxRouteLength: 34, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執油漬中間咖啡' },
      { type: 'efficiency', maxLength: 31, text: '路線長度 ≤ 31 格' },
    ],
    rewards: { coffee: 124, materials: 42 },
    hint: '油漬好跣——入到油區轉唔到彎，入油區前事先 plan 定直線！',
  },
  {
    id: 'storm_021',
    region: 'storm',
    name: '溜冰返工',
    tags: ['oil', 'maze'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 三道閘牆（頂、底、頂）
    terrain: [
      [{ x: 5, y: 3 }, { x: 6, y: 3 }, { x: 6, y: 12 }, { x: 5, y: 12 }],
      [{ x: 9, y: 0 }, { x: 10, y: 0 }, { x: 10, y: 9 }, { x: 9, y: 9 }],
      [{ x: 13, y: 3 }, { x: 14, y: 3 }, { x: 14, y: 12 }, { x: 13, y: 12 }],
    ],
    // 全場油漬
    oilZones: [{ x: 2.5, y: 1, w: 15, h: 10 }],
    currents: [], windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 7.5, y: 6, r: 0.55 },
      { id: 's2', x: 11.5, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 44, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 41, text: '路線長度 ≤ 41 格' },
    ],
    rewards: { coffee: 128, materials: 42 },
    hint: '成個場都係油——好似溜冰咁，直線衝、唔好急彎！',
  },
  {
    id: 'river_014',
    region: 'river',
    name: '彈彈椅陣',
    tags: ['tutorial', 'bumper'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    currents: [], windZones: [],
    // 新元素：彈彈椅——撞到會彈開，但唔扣血
    bumpers: [
      { x: 10, y: 2.8, r: 1.0, power: 6 },
      { x: 7, y: 4.3, r: 1.0, power: 6 },
      { x: 13, y: 4.3, r: 1.0, power: 6 },
      { x: 7, y: 7.7, r: 1.0, power: 6 },
      { x: 13, y: 7.7, r: 1.0, power: 6 },
      { x: 10, y: 9.2, r: 1.0, power: 6 },
    ],
    hazards: [
      { x: 4, y: 2, r: 0.6, damage: 30 },
      { x: 16, y: 10, r: 0.6, damage: 30 },
    ],
    collectibles: [
      { id: 's1', x: 10, y: 6, r: 0.55 },
      { id: 's2', x: 17.4, y: 1.6, r: 0.55 },
    ],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 23, text: '路線長度 ≤ 23 格' },
    ],
    rewards: { coffee: 132, materials: 44 },
    hint: '彈彈椅彈到你飛起——唔扣血，但會彈離路線，小心啲行！',
  },
  {
    id: 'storm_022',
    region: 'storm',
    name: '人夾人陀螺',
    tags: ['vortex', 'osc'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 中央迴旋＋上下擺動人潮帶
    currents: [
      { vortex: { cx: 10, cy: 6, r: 2.6, s: 2.4 } },
      { x: 4, y: 0.7, w: 12, h: 1.6, fx: 1.8, fy: 0, osc: { amp: 1.2, speed: 1.3 } },
      { x: 4, y: 9.7, w: 12, h: 1.6, fx: -1.4, fy: 0, osc: { amp: 1.2, speed: 1.3, phase: 1.5 } },
    ],
    windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 5, y: 6, r: 0.55 }],
    rules: { maxRouteLength: 22, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執陀螺前咖啡' },
      { type: 'efficiency', maxLength: 19, text: '路線長度 ≤ 19 格' },
    ],
    rewards: { coffee: 138, materials: 46 },
    hint: '人潮陀螺加擺動帶——由陀螺上方弧線繞過去！',
  },
  {
    id: 'storm_023',
    region: 'storm',
    name: '油漬疫症',
    tags: ['oil', 'night', 'split'],
    theme: 'night',
    start: { x: 2, y: 2 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    terrain: [],
    oilZones: [{ x: 5, y: 3, w: 10, h: 6 }],
    currents: [], windZones: [],
    hazards: [
      { x: 10, y: 6, r: 0.85, damage: 35, split: { maxGen: 1 } },
      { x: 16, y: 8, r: 0.65, damage: 45 },
    ],
    collectibles: [
      { id: 's1', x: 8, y: 1.5, r: 0.55 },
      { id: 's2', x: 18.5, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 27, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 24, text: '路線長度 ≤ 24 格' },
    ],
    rewards: { coffee: 144, materials: 48 },
    hint: '夜黑油滑仲有分裂病菌——貼住上邊行，繞大彎！',
  },
  {
    id: 'storm_024',
    region: 'storm',
    name: '煉獄終章',
    tags: ['final', 'boss', 'night', 'oil', 'vortex', 'bumper', 'heal'],
    theme: 'night',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [],
    // 油漬＋陀螺＋彈彈椅＋分裂＋巡邏全開
    oilZones: [{ x: 6, y: 4, w: 8, h: 5 }],
    currents: [{ vortex: { cx: 10, cy: 2.2, r: 2.2, s: 2.0 } }],
    windZones: [],
    bumpers: [
      { x: 5, y: 9.5, r: 0.9, power: 6 },
      { x: 15, y: 9.5, r: 0.9, power: 6 },
    ],
    hazards: [
      { x: 10, y: 6.5, r: 0.85, damage: 35, split: { maxGen: 1 } },
      { x: 17.3, y: 6, r: 0.6, damage: 30, patrol: { x0: 17.3, y0: 3, x1: 17.3, y1: 9, speed: 1.6 } },
    ],
    collectibles: [
      { id: 'h1', x: 13, y: 11.2, r: 0.55, heal: 35 },
      { id: 's1', x: 18.8, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.6, durability: 60, turn_resistance: 0.32, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊咖啡同凍檸茶' },
      { type: 'efficiency', maxLength: 29, text: '路線長度 ≤ 29 格' },
    ],
    rewards: { coffee: 160, materials: 52 },
    hint: '煉獄終章——油漬、陀螺、彈彈椅、病菌全部一次過，撐住呀黎先生！',
  },

  // ============ 地鐵早高峰（57-61）============
  // 新元素：閘機（gates）——週期開合，開啟先過到（active=true＝關閉）
  {
    id: 'river_015',
    region: 'river',
    name: '入閘機',
    tags: ['tutorial', 'gate'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 三道閘機輪流開合
    gates: [
      { poly: [{ x: 7, y: 0 }, { x: 7.8, y: 0 }, { x: 7.8, y: 12 }, { x: 7, y: 12 }], period: 3, duty: 0.3 },
      { poly: [{ x: 11, y: 0 }, { x: 11.8, y: 0 }, { x: 11.8, y: 12 }, { x: 11, y: 12 }], period: 3, duty: 0.3, phase: 1.5 },
      { poly: [{ x: 15, y: 0 }, { x: 15.8, y: 0 }, { x: 15.8, y: 12 }, { x: 15, y: 12 }], period: 3, duty: 0.3, phase: 0.5 },
    ],
    currents: [], windZones: [], hazards: [],
    collectibles: [{ id: 's1', x: 9, y: 6, r: 0.55 }],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執閘機之間咖啡' },
      { type: 'efficiency', maxLength: 17, text: '路線長度 ≤ 17 格' },
    ],
    rewards: { coffee: 165, materials: 54 },
    hint: '閘機會開合——實心嗰陣撞到會傷，開住（虛線）先好過！',
  },
  {
    id: 'harbor_020',
    region: 'harbor',
    name: '迫過閘機',
    tags: ['gate', 'crowd'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    terrain: [],
    // 兩道閘機＋一條順推人潮帶（借力衝閘）
    gates: [
      { poly: [{ x: 8, y: 0 }, { x: 8.8, y: 0 }, { x: 8.8, y: 12 }, { x: 8, y: 12 }], period: 3.2, duty: 0.35 },
      { poly: [{ x: 13, y: 0 }, { x: 13.8, y: 0 }, { x: 13.8, y: 12 }, { x: 13, y: 12 }], period: 3.2, duty: 0.35, phase: 1.5 },
    ],
    currents: [{ x: 4, y: 4.5, w: 12, h: 3, fx: 1.2, fy: 0 }],
    windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 6, y: 6, r: 0.55 },
      { id: 's2', x: 16, y: 6, r: 0.55 },
    ],
    rules: { maxRouteLength: 22, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 18, text: '路線長度 ≤ 18 格' },
    ],
    rewards: { coffee: 170, materials: 56 },
    hint: '順住人潮衝力衝過閘機——人流推你一把，把握開閘一刻！',
  },
  {
    id: 'storm_025',
    region: 'storm',
    name: '轉車站',
    tags: ['gate', 'maze'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 10, r: 1.1 }],
    // 固定月台牆＋閘門交替（x6/x10/x14 各一半固定、一半閘機）
    terrain: [
      [{ x: 6, y: 0 }, { x: 6.8, y: 0 }, { x: 6.8, y: 5 }, { x: 6, y: 5 }],
      [{ x: 10, y: 6 }, { x: 10.8, y: 6 }, { x: 10.8, y: 12 }, { x: 10, y: 12 }],
      [{ x: 14, y: 0 }, { x: 14.8, y: 0 }, { x: 14.8, y: 5 }, { x: 14, y: 5 }],
    ],
    gates: [
      { poly: [{ x: 6, y: 5 }, { x: 6.8, y: 5 }, { x: 6.8, y: 12 }, { x: 6, y: 12 }], period: 3, duty: 0.4 },
      { poly: [{ x: 10, y: 0 }, { x: 10.8, y: 0 }, { x: 10.8, y: 6 }, { x: 10, y: 6 }], period: 3, duty: 0.4, phase: 0 },
      { poly: [{ x: 14, y: 5 }, { x: 14.8, y: 5 }, { x: 14.8, y: 12 }, { x: 14, y: 12 }], period: 3, duty: 0.4, phase: 0.9 },
    ],
    currents: [], windZones: [], hazards: [],
    collectibles: [
      { id: 's1', x: 8.3, y: 10.2, r: 0.55 },
      { id: 's2', x: 12.4, y: 4.4, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊 2 杯月台咖啡' },
      { type: 'efficiency', maxLength: 30, text: '路線長度 ≤ 30 格' },
    ],
    rewards: { coffee: 176, materials: 58 },
    hint: '轉車站上落穿梭——固定牆繞路，閘門睇時間！',
  },
  {
    id: 'harbor_021',
    region: 'harbor',
    name: '尾班車',
    tags: ['gate', 'night', 'timed'],
    theme: 'night',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [],
    gates: [
      { poly: [{ x: 9, y: 0 }, { x: 9.8, y: 0 }, { x: 9.8, y: 12 }, { x: 9, y: 12 }], period: 3, duty: 0.35 },
    ],
    currents: [], windZones: [],
    hazards: [
      { x: 5, y: 3, r: 0.65, damage: 45 },
      { x: 5, y: 9, r: 0.65, damage: 45 },
    ],
    collectibles: [
      { id: 'h1', x: 15, y: 3, r: 0.55, heal: 30 },
      { id: 's1', x: 12, y: 10.5, r: 0.55 },
    ],
    rules: { maxRouteLength: 27, inkUses: 1, timeLimit: 26 },
    boat: { speed: 3.3, durability: 90, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '執齊咖啡同凍檸茶' },
      { type: 'efficiency', maxLength: 25, text: '路線長度 ≤ 25 格' },
    ],
    rewards: { coffee: 184, materials: 60 },
    hint: '尾班車26秒後開出——閘機開嗰下即刻衝！',
  },
  {
    id: 'storm_026',
    region: 'storm',
    name: '衝閘終點',
    tags: ['final', 'boss', 'gate', 'night', 'timed', 'vortex', 'split'],
    theme: 'night',
    start: { x: 2, y: 10 },
    destinations: [{ id: 'home_01', x: 18, y: 2, r: 1.1 }],
    terrain: [],
    // 兩道全閘＋迴旋人潮＋分裂病菌
    gates: [
      { poly: [{ x: 6, y: 0 }, { x: 6.8, y: 0 }, { x: 6.8, y: 12 }, { x: 6, y: 12 }], period: 3, duty: 0.35 },
      { poly: [{ x: 12, y: 0 }, { x: 12.8, y: 0 }, { x: 12.8, y: 12 }, { x: 12, y: 12 }], period: 3, duty: 0.35, phase: 1.6 },
    ],
    currents: [{ vortex: { cx: 15, cy: 6, r: 2.2, s: 2.2 } }],
    windZones: [],
    hazards: [
      { x: 9, y: 6, r: 0.85, damage: 35, split: { maxGen: 1 } },
    ],
    collectibles: [{ id: 's1', x: 10, y: 10.6, r: 0.55 }],
    rules: { maxRouteLength: 28, inkUses: 1, timeLimit: 24 },
    boat: { speed: 3.6, durability: 70, turn_resistance: 0.32, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collect', target: 's1', text: '執閘間咖啡' },
      { type: 'efficiency', maxLength: 26, text: '路線長度 ≤ 26 格' },
    ],
    rewards: { coffee: 200, materials: 64 },
    hint: '最後衝閘——24 秒、兩道閘、陀螺同分裂病菌，衝呀！',
  },

  // ============ 順路任務（62-66）============
  // 新元素：多站順序到訪（destinations 陣列＝順序，去齊先打卡）＋咖啡因衝刺（boost 限時加速）
  {
    id: 'river_016',
    region: 'river',
    name: '買早餐先',
    tags: ['tutorial', 'multistop'],
    start: { x: 2, y: 6 },
    // 站 1＝便利店，站 2＝公司（順序到訪）
    destinations: [
      { id: 'stop_1', x: 8, y: 2, r: 1.1 },
      { id: 'home_01', x: 18, y: 6, r: 1.1 },
    ],
    terrain: [],
    currents: [{ x: 4, y: 0.8, w: 6, h: 2.4, fx: 1.0, fy: 0 }],
    windZones: [], hazards: [],
    collectibles: [],
    rules: { maxRouteLength: 20, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '順路買早餐再返公司' },
      { type: 'noCollision', text: '全程不碰撞' },
      { type: 'efficiency', maxLength: 19, text: '路線長度 ≤ 19 格' },
    ],
    rewards: { coffee: 210, materials: 66 },
    hint: '要順路：先去便利店（1號）買早餐，再返公司（2號）打卡！',
  },
  {
    id: 'harbor_022',
    region: 'harbor',
    name: '順路收衫',
    tags: ['multistop', 'precision'],
    start: { x: 2, y: 2 },
    destinations: [
      { id: 'stop_1', x: 6, y: 10, r: 1.1 },
      { id: 'home_01', x: 18, y: 6, r: 1.1 },
    ],
    // 中央工地（下方繞過）
    terrain: [[{ x: 9, y: 4 }, { x: 12, y: 4 }, { x: 12, y: 8 }, { x: 9, y: 8 }]],
    currents: [],
    windZones: [{ x: 13, y: 1, w: 6, h: 4, fx: 0.6, fy: 1.4 }],
    hazards: [{ x: 15, y: 10, r: 0.65, damage: 45 }],
    collectibles: [{ id: 's1', x: 13, y: 10.8, r: 0.55 }],
    rules: { maxRouteLength: 26, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '收完衫再返公司' },
      { type: 'collect', target: 's1', text: '執埋下面咖啡' },
      { type: 'efficiency', maxLength: 24, text: '路線長度 ≤ 24 格' },
    ],
    rewards: { coffee: 216, materials: 68 },
    hint: '先去 1號收衫，再返 2號公司——工地下面兜過去！',
  },
  {
    id: 'storm_027',
    region: 'storm',
    name: '落單外賣',
    tags: ['multistop', 'hazard'],
    start: { x: 2, y: 6 },
    destinations: [
      { id: 'stop_1', x: 5, y: 10, r: 1.1 },
      { id: 'stop_2', x: 12, y: 2, r: 1.1 },
      { id: 'home_01', x: 18, y: 9, r: 1.1 },
    ],
    terrain: [],
    currents: [],
    windZones: [{ x: 8, y: 3, w: 10, h: 6, fx: 0.5, fy: 1.2 }],
    hazards: [
      { x: 10, y: 6, r: 0.65, damage: 45 },
      { x: 15, y: 3, r: 0.65, damage: 45 },
      { x: 16, y: 6.5, r: 0.6, damage: 30, patrol: { x0: 16, y0: 4, x1: 16, y1: 9, speed: 1.4 } },
    ],
    collectibles: [
      { id: 's1', x: 5, y: 2, r: 0.55 },
      { id: 's2', x: 18, y: 2, r: 0.55 },
    ],
    rules: { maxRouteLength: 32, inkUses: 1 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '去齊三個站打卡' },
      { type: 'collectAll', text: '執齊 2 杯咖啡' },
      { type: 'efficiency', maxLength: 30, text: '路線長度 ≤ 30 格' },
    ],
    rewards: { coffee: 224, materials: 70 },
    hint: '1號落單→2號攞外賣→3號返公司，順序唔可以亂！',
  },
  {
    id: 'river_017',
    region: 'river',
    name: '咖啡因上腦',
    tags: ['tutorial', 'boost', 'timed'],
    start: { x: 2, y: 6 },
    destinations: [{ id: 'home_01', x: 18, y: 6, r: 1.1 }],
    // 單工地（底隙）——特濃咖啡放喺長直路上
    terrain: [
      [{ x: 5.5, y: 0 }, { x: 7.5, y: 0 }, { x: 7.5, y: 7 }, { x: 5.5, y: 7 }],
    ],
    currents: [], windZones: [],
    hazards: [],
    // 新元素：咖啡因（boost）——執到限時 ×1.6 衝刺（加速時轉彎好闊，要喺直路用）
    collectibles: [
      { id: 'b1', x: 13, y: 10.5, r: 0.55, boost: 3 },
      { id: 'b2', x: 17.5, y: 6.5, r: 0.55, boost: 3 },
    ],
    rules: { maxRouteLength: 30, inkUses: 1, timeLimit: 20 },
    boat: { speed: 3.3, durability: 100, turn_resistance: 0.4, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '準時打卡' },
      { type: 'collectAll', text: '飲齊 2 杯特濃咖啡' },
      { type: 'efficiency', maxLength: 28, text: '路線長度 ≤ 28 格' },
    ],
    rewards: { coffee: 232, materials: 72 },
    hint: '特濃咖啡限時加速——衝刺時轉彎好闊，喺直路先好飲！',
  },
  {
    id: 'storm_028',
    region: 'storm',
    name: '買齊先返到',
    tags: ['final', 'boss', 'multistop', 'gate', 'night', 'timed'],
    theme: 'night',
    start: { x: 2, y: 6 },
    destinations: [
      { id: 'stop_1', x: 10, y: 2, r: 1.1 },
      { id: 'stop_2', x: 10, y: 10, r: 1.1 },
      { id: 'home_01', x: 18, y: 6, r: 1.1 },
    ],
    terrain: [],
    // 兩道全閘（相位由測試調校）
    gates: [
      { poly: [{ x: 6, y: 0 }, { x: 6.8, y: 0 }, { x: 6.8, y: 12 }, { x: 6, y: 12 }], period: 3, duty: 0.35 },
      { poly: [{ x: 14, y: 0 }, { x: 14.8, y: 0 }, { x: 14.8, y: 12 }, { x: 14, y: 12 }], period: 3, duty: 0.35, phase: 0.3 },
    ],
    currents: [], windZones: [],
    hazards: [
      { x: 12, y: 6, r: 0.85, damage: 35, split: { maxGen: 1 } },
    ],
    collectibles: [{ id: 'h1', x: 3, y: 2, r: 0.55, heal: 30 }],
    rules: { maxRouteLength: 32, inkUses: 1, timeLimit: 26 },
    boat: { speed: 3.4, durability: 80, turn_resistance: 0.35, wind_affinity: 1 },
    goals: [
      { type: 'deliver', text: '去齊三個站打卡' },
      { type: 'collect', target: 'h1', text: '執埋開場凍檸茶' },
      { type: 'efficiency', maxLength: 30, text: '路線長度 ≤ 30 格' },
    ],
    rewards: { coffee: 250, materials: 78 },
    hint: '終極順路任務——閘機、分裂病菌、26 秒，三個站買齊先返到！',
  },
];

export function levelById(id) {
  return LEVELS.find((l) => l.id === id);
}
